export default __webpack_public_path__ + "static/media/img6.42df57e8.PNG";